export default __webpack_public_path__ + "static/media/Icon-2.da3b4336.gif";